webpackJsonp([73],{

/***/ 1268:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1269);


/***/ }),

/***/ 1269:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(174);

var _datetime2 = _interopRequireDefault(_datetime);

var _ja = __webpack_require__(778);

var _ja2 = _interopRequireDefault(_ja);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('ja', _ja2.default);

/***/ })

},[1268]);


// WEBPACK FOOTER //
// app/datetime.ja-0931a9791ea7c68aef04.js